"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportData = void 0;
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const snackbar_context_1 = require("../../../composite/snackbar/snackbar-context");
const snackbar_types_1 = require("../../../composite/snackbar/snackbar-types");
const crud_source_hook_1 = require("../../../utils/crud-source-hook");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const reporting_context_1 = require("../reporting-context");
function useReportData({ id }) {
    const intl = (0, react_intl_1.useIntl)();
    const { showSnackbar } = (0, react_1.useContext)(snackbar_context_1.SnackbarContext);
    const { url, generate } = (0, react_1.useContext)(reporting_context_1.ReportingContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const formRef = (0, react_1.useRef)(null);
    const resultRef = (0, react_1.useRef)(null);
    const source = (0, crud_source_hook_1.useCrudSource)({
        url,
        handleGetError: lodash_1.noop,
    });
    const handleGenerate = (0, event_callback_hook_1.useEventCallback)(async () => {
        var _a;
        if (id === undefined) {
            return;
        }
        try {
            setLoading(true);
            const input = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.getFieldValues();
            const report = await generate(id, input !== null && input !== void 0 ? input : {});
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                source.reset(report);
                setLoading(false);
            });
        }
        catch (err) {
            setLoading(false);
            if (err.name !== 'AbortError') {
                const message = intl.formatMessage({
                    id: 'EAS_REPORTING_DATA_ERROR_LOADING',
                    defaultMessage: 'Chyba načtení reportu',
                });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
            }
            return undefined;
        }
    });
    (0, react_1.useEffect)(() => {
        if (id !== undefined) {
            source.reset();
            source.get(id);
        }
        else {
            source.reset();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = resultRef.current) === null || _a === void 0 ? void 0 : _a.setFieldValues(source.data);
    }, [source.data]);
    return {
        source,
        generate: handleGenerate,
        loading,
        formRef,
        resultRef,
    };
}
exports.useReportData = useReportData;
//# sourceMappingURL=data-hook.js.map